module.exports = __webpack_public_path__ + "img/today.e578b907.svg";